/**
 * @generated SignedSource<<cd9adb6a6f0e968382c0ac729a2127ba>>
 * @relayHash e5e64a8b43d711a4552fc165f525eafc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 12e6491b353b579ff6276ca34e83e2ff49a6994704767f8e5e031d2896f3c5b2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AriGraphRelationshipsSortDirection = "ASC" | "DESC" | "%future added value";
export type AriGraphRelationshipsSort = {
  lastUpdatedSortDirection?: AriGraphRelationshipsSortDirection | null | undefined;
};
export type mainSoftwareCodePagePullRequestsListRefetch$variables = {
  cloudId: string;
  first?: number | null | undefined;
  projectKey: string;
  sort?: AriGraphRelationshipsSort | null | undefined;
  updatedFrom: AGG$DateTime;
};
export type mainSoftwareCodePagePullRequestsListRefetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_PullRequestsList">;
};
export type mainSoftwareCodePagePullRequestsListRefetch = {
  response: mainSoftwareCodePagePullRequestsListRefetch$data;
  variables: mainSoftwareCodePagePullRequestsListRefetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  },
  {
    "defaultValue": {
      "lastUpdatedSortDirection": "DESC"
    },
    "kind": "LocalArgument",
    "name": "sort"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updatedFrom"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "sort"
},
v4 = {
  "kind": "Variable",
  "name": "updatedFrom",
  "variableName": "updatedFrom"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  (v5/*: any*/),
  {
    "kind": "ScalarField",
    "name": "accountId"
  },
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "url"
},
v10 = [
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainSoftwareCodePagePullRequestsListRefetch",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "main_softwareCodePage_PullRequestsList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainSoftwareCodePagePullRequestsListRefetch",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      (v4/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-pr"
                  }
                ],
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "devOpsEntityRelationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "status"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "repositoryName"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "repositoryId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "author",
                                        "plural": false,
                                        "selections": (v8/*: any*/)
                                      },
                                      {
                                        "concreteType": "DevOpsReviewer",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": (v8/*: any*/)
                                          },
                                          (v5/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "approvalStatus"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "userId"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "title"
                                      },
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "lastUpdated"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "commentCount"
                                      },
                                      (v9/*: any*/),
                                      {
                                        "concreteType": "DevOpsBranchInfo",
                                        "kind": "LinkedField",
                                        "name": "destinationBranch",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "pullRequestInternalId"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "repositoryUrl"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "authorId"
                                      }
                                    ],
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "ConfluencePage"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "ConfluenceSpace"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "DevOpsFeatureFlag"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "DevOpsOperationsComponentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "DevOpsOperationsIncidentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "DevOpsRepository"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "JiraConfluenceRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "JiraCustomRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "JiraIssueRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "JiraWebRemoteIssueLink"
                                  }
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "12e6491b353b579ff6276ca34e83e2ff49a6994704767f8e5e031d2896f3c5b2",
    "metadata": {},
    "name": "mainSoftwareCodePagePullRequestsListRefetch",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "54ad227e3409b5d5a913af71c2eddfc7";

export default node;
